
import { Icon } from "@portal/lib/icons/icons";
import { ValidFileType } from "@portal/types/file";

const DOC_TYPE_ICONS: Record<ValidFileType, React.ReactNode> = {
  PDF: <Icon color={"var(--red-7)"} icon={['far','file-pdf']} />,
  JPG: <Icon color={"var(--geekblue-6)"} icon={['far','file-image']} />,
  PNG: <Icon color={"var(--geekblue-6)"} icon={['far','file-image']} />,
  DOC: <Icon color={"var(--blue-6)"} icon={['far','file-word']} />,
  XLS: <Icon color={"var(--green-7)"} icon={['far','file-excel']} />,
  CSV: <Icon color={"var(--green-6)"} icon={['far','file-csv']} />,
  XLSX: <Icon color={"var(--green-7)"} icon={['far','file-excel']} />,
  EML: <Icon color={"var(--geekblue-6)"} icon={['far','envelopes']} />,
};

export function getDocTypeIcon(docType: ValidFileType) {
  return DOC_TYPE_ICONS[docType];
}
